import {
  MapAlertCamera,
  MapAlertCameraGroup,
} from 'features/cameras/cameras.types';

/**
 * Group cameras by cluster id so we can display them as related cameras
 * on the map. This also updates cameras with more recent realtime data
 * (azimuth, FOV) so that all rendered icons and viewsheds are painted with
 * the current positioning.
 */
export const groupCamerasByClusterId = <T extends MapAlertCamera>(
  cameras: T[],
): MapAlertCameraGroup<T>[] => {
  const clusterToCamera = cameras.reduce<Record<string, T[]>>(
    (acc, camera: T) => {
      if (!camera.cluster) return acc;

      const clusterId = camera.cluster.id;

      if (acc[clusterId]) {
        acc[clusterId].push(camera);
      } else {
        acc[clusterId] = [camera];
      }

      return acc;
    },
    {},
  );

  return Object.values(clusterToCamera).map((camerasInCluster: T[]) => {
    const { id, latlng, hasPtz } = camerasInCluster[0].cluster!;

    // Set the latlng for all cameras to that of the cluster.
    // This ensures that camera ptz arrows and view sheds are drawn at the correct location.
    const cameraGroup = camerasInCluster.map((camera) => ({
      ...camera,
      latlng,
      cameraGroupId: id,
    }));

    return {
      id,
      latlng,
      hasPtz,
      cameras: cameraGroup,
    };
  });
};
